import React from "react";
import styles from "./Gallery.module.css";

import img1 from "../assets/img1.jpeg";
import img2 from "../assets/img2.jpeg";
import img3 from "../assets/img3.jpeg";
import img4 from "../assets/img4.jpeg";
import img5 from "../assets/img5.jpeg";
import img10 from "../assets/img10.jpeg";
import img11 from "../assets/img11.jpeg";
import img13 from "../assets/img13.jpeg";
import img14 from "../assets/img14.jpeg";
import img15 from "../assets/img15.jpeg";
import gly4 from "../assets/gly4.jpeg";

import glry3 from "../assets/glry3.jpeg";
import glry2 from "../assets/glry2.jpeg";
import gly8 from "../assets/gly8.jpeg";
import gly9 from "../assets/gly9.jpeg";
import gly10 from "../assets/gly10.jpeg";
import gly11 from "../assets/gly11.jpeg";
import gly5 from "../assets/gly5.jpeg";
import gly6 from "../assets/gly6.jpeg";
import gallery1 from "../assets/gallery1.jpeg";
import vc1 from "../assets/vedio/vc1.mp4";
import vc2 from "../assets/vedio/vc2.mp4";
import vd3 from "../assets/vedio/vd3.mp4";
import { Helmet } from "react-helmet";
const Gallery = () => {
  return (
    <>
    <Helmet>
        <title>Gallery - Saraswati Vidya Mandir</title>
        <meta name="description" content="Explore the vibrant gallery of Saraswati Vidya Mandir, showcasing our students' achievements, events, and the lively campus life that defines our school community." />
      </Helmet>

    <div className={styles.galleryPage}>

      {/* 🔥 HERO */}
      <section className={styles.hero}>
        <h1>Our Gallery</h1>
        <p>Moments that define our journey</p>
      </section>

      {/* 🖼️ IMAGE GALLERY */}
      <section className={styles.section}>
        <h2 className={styles.title}>Photo Gallery</h2>

        <div className={styles.galleryGrid}>
          {[img1, img2, img3, img4, img5, img10, img11, img13, img14, img15 ,gly4 ,gly5, gallery1 , gly6 , gly8 , gly9 , gly10 , gly11, glry3, glry2 ].map((img, i) => (
            <div key={i} className={styles.card}>
              <img src={img} alt="gallery" />
            </div>
          ))}
        </div>
      </section>

      {/* 🎥 VIDEO GALLERY */}
     {/* 🎥 VIDEO GALLERY */}
<section className={styles.section}>
  <h2 className={styles.title}>Video Gallery</h2>

  <div className={styles.videoGrid}>

    <video controls>
      <source src={vc1} type="video/mp4" />
    </video>

    <video controls>
      <source src={vc2} type="video/mp4" />
    </video>

    <video controls>
      <source src={vd3} type="video/mp4" />
    </video>

  </div>
</section>
        

    </div>
    </>
  );
};

export default Gallery;